import { h, ComponentChildren } from 'preact'
import Icon from '../assets'

type Props = {
  icon: any,
  iconClass?: string,
  title: string,
  children: ComponentChildren
}

const ImportBox = ({ icon, iconClass, title, children }: Props) => {
  return (
    <div className='message-container'>
      <Icon customClass={iconClass} icon={icon} width={80} height={80} />
      <div className='upload-message-text'>{title}</div>
      <div>{children}</div>
    </div>
  )
}

export default ImportBox
